/* DICTIONARIES */
export const GET_DICTIONARIES = "GET_DICTIONARIES"
export const GET_DICTIONARIES_SUCCESS = "GET_DICTIONARIES_SUCCESS"
export const GET_DICTIONARIES_FAIL = "GET_DICTIONARIES_FAIL"

export const GET_REGIONS = "GET_REGIONS"
export const GET_REGIONS_SUCCESS = "GET_REGIONS_SUCCESS"
export const GET_REGIONS_FAIL = "GET_REGIONS_FAIL"